import { RouterRootState } from "connected-react-router";
import React, { FC, ReactNode, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Link, useHistory } from "react-router-dom";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { toast } from "react-toastify";
import CompaniesTab from "../../../containers/companies-tab";
import { useLocale } from "../../../contexts/localeContext";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { Button } from "../../../components/button/Button";
import plusIcon from "../../../images/Plus.svg";
import { Category } from "../../../models/Category";
import { showError } from "../../../services/utilities/ServiceError";
import {Filter} from "../../../models/Filter";
import { getListOfSiteIdsFromFilter, shouldUpdateCategory } from "../../../utilities/tabUtils";
import { useTabCount } from "../../../hooks/useCategoryTab";

const getRouteNameFromPath = (path: string) => {
    const splitPath = path.split("/");
    return splitPath[splitPath.length - 1];
};
const Companies: FC = () => {
    const [selected, setSelected] = useState(0);
    const [busy, setBusy] = useState(false);
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([]);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    const { translate } = useLocale();
    const routeName = useSelector((state: RouterRootState) => getRouteNameFromPath(state.router.location.pathname));

    const { updateTabCount } = useTabCount({
        tableName: "Company",
        categories,
        setCategories,
    });

    useEffect(() => {
        buildCategoriesData(); 
    }, []);

    const buildCategoriesData = async () => {
        try {
            setBusy(true);
            setCategories([
                {
                    displayName: translate.byKey(TranslationKeys.companies),
                    heading: translate.byKey(TranslationKeys.companies),
                    value: "",
                    id: 0,
                    count: 1,
                },
            ]);
        } catch (error) {
            showError(error, toast.warn);
        } finally {
            setBusy(false);
        }
    };

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <CompaniesTab
                    setBusy={setBusy}
                    categories={categories}
                    setCategories={setCategories}
                    onFilterChange={onFilterChange}
                />,
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);

    const onFilterChange = (filters: Filter[]) => {
        const siteIds = getListOfSiteIdsFromFilter(filters);
        updateTabCount(siteIds)
    };

    return (
        <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
            <div id="container-tabs" className="pt-4 pl-4 pb-4 flex flex-col flex-grow ">
                <Breadcrumb
                    path={[
                        {
                            value: "/access-control/enrolment",
                            displayName: translate.byKey(
                                TranslationKeys.enrolments
                            ),
                        },
                        {
                            value: "/access-control/enrolment/companies",
                            displayName: translate.byKey(
                                TranslationKeys.companies
                            ),
                        },
                    ]}
                    onClick={(item) => history.push(item.value)}
                />
                <Tabs
                    tabStyle={{}}
                    className="overflow-y-hidden"
                    tabs={getTabsListFromLabels(categories)}
                    onSelect={(i) => setSelected(i)}
                    selected={selected}
                    onAdd={() => {}}
                    add={false}
                >
                    {tabContent[selected]}
                    <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                        <div className="flex flex-row justify-end button-cluster">
                            <Restricted to={`add.${routeName}.element`}>
                                <Link
                                    to={{
                                        pathname:
                                            "/access-control/enrolment/company/",
                                    }}
                                >
                                    <Button
                                        variant="submit"
                                        shape="rounded"
                                        id="companiesAddButtonId"
                                    >
                                        <img
                                            src={plusIcon}
                                            className="px-2 w-8 py-1"
                                            alt=""
                                        />
                                        <span className="mr-2">
                                            {translate.byKey(
                                                TranslationKeys.add
                                            )}
                                        </span>
                                    </Button>
                                </Link>
                            </Restricted>
                        </div>
                    </div>
                </Tabs>
            </div>
        </ActivityFrame>
    );
};

export default Companies;
